/* eslint-disable import/no-anonymous-default-export */
import { useCallback } from 'react'
import { useAppDispatch } from '../store/hooks'
import LocalStorage from '../utils/helpers/LocalStorage'
import { authCreators } from '../store/ducks/auth'
import { profileRepository } from '@/repositories'

let didInit = false

function useRestoreSession() {
	const dispatch = useAppDispatch()

	const restoreSession = useCallback(() => {
		const storage = new LocalStorage()

		const sessionToken = storage.get('token')

		if (!sessionToken) {
			return
		}
		dispatch(authCreators.resetAuthState())
		dispatch(profileRepository.util.invalidateTags(['Profile']))
		dispatch(authCreators.authenticate({ token: sessionToken }))
	}, [dispatch])

	if (!didInit) {
		didInit = true
		restoreSession()
	}
}

export default {
	restoreSession: useRestoreSession,
}
